import { render, staticRenderFns } from "./Notif.vue?vue&type=template&id=d875212a&lang=pug"
import script from "./Notif.vue?vue&type=script&lang=js"
export * from "./Notif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports